// Utility functions for ChatComponent

import { isCompletedPlanResultMessage, isPlanChatMessage, isPlanType, restorePlanConversationState } from './planUtils';

export const formatTimestamp = (date) => {
  const dateObj = new Date(date);
  const now = new Date();
  const isToday =
    dateObj.getDate() === now.getDate() &&
    dateObj.getMonth() === now.getMonth() &&
    dateObj.getFullYear() === now.getFullYear();

  return isToday
    ? dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
    : dateObj.toLocaleString([], {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
};

export const mergeAssistantMessages = (messages, successStatus = 'success', projectId) => {
  const hydrated = restorePlanConversationState(messages ?? [], projectId);
  const merged = [];
  for (const msg of hydrated) {
    const last = merged[merged.length - 1];
    const canMerge =
      last &&
      last.role === 'assistant' &&
      msg.role === 'assistant' &&
      !isPlanChatMessage(last) &&
      !isPlanChatMessage(msg) &&
      !isPlanType(last) &&
      !isPlanType(msg) &&
      !isCompletedPlanResultMessage(last) &&
      !isCompletedPlanResultMessage(msg);
    if (canMerge) {
      merged[merged.length - 1] = {
        ...last,
        content: (last.content || '') + '\n\n' + (msg.content || ''),
      };
    } else {
      merged.push({ ...msg, jobStatus: msg.jobStatus || successStatus });
    }
  }

  const lastMsg = merged[merged.length - 1];
  if (lastMsg && lastMsg.role === 'assistant' && !isPlanChatMessage(lastMsg)) {
    merged[merged.length - 1] = { ...lastMsg, jobStatus: successStatus };
  }

  return merged;
};

export const copyToClipboard = async (text, buttonElement, iconElement) => {
  try {
    await navigator.clipboard.writeText(text);
    
    if (buttonElement && iconElement) {
      buttonElement.setAttribute('data-copied', 'true');
      
      const tooltip = createTooltip('Copied!');
      buttonElement.style.position = 'relative';
      buttonElement.appendChild(tooltip);
      
      iconElement.classList.add('icon-transform');
      setTimeout(() => {
        iconElement.className = 'fa-solid fa-check icon-transform';
      }, 300);
      
      setTimeout(() => {
        tooltip.style.animation = 'tooltipFadeOut 0.3s ease-in forwards';
        setTimeout(() => tooltip.remove(), 300);
        
        setTimeout(() => {
          iconElement.className = 'fa-solid fa-copy';
          buttonElement.removeAttribute('data-copied');
          buttonElement.style.color = '#64748b';
          buttonElement.style.backgroundColor = 'transparent';
          buttonElement.style.transform = 'scale(1)';
        }, 500);
      }, 2500);
    }
  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
};

const createTooltip = (text) => {
  const tooltip = document.createElement('div');
  tooltip.textContent = text;
  tooltip.style.cssText = `
    position: absolute; top: -35px; left: 50%; transform: translateX(-50%);
    background: #1e293b; color: white; padding: 6px 10px; border-radius: 6px;
    font-size: 11px; font-weight: 500; white-space: nowrap; z-index: 1000;
    opacity: 0; animation: tooltipFadeIn 0.3s ease-out forwards;
    pointer-events: none; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  `;
  
  const arrow = document.createElement('div');
  arrow.style.cssText = `
    position: absolute; top: 100%; left: 50%; transform: translateX(-50%);
    width: 0; height: 0; border-left: 4px solid transparent;
    border-right: 4px solid transparent; border-top: 4px solid #1e293b;
  `;
  tooltip.appendChild(arrow);
  
  return tooltip;
};

